<template>
  <div class="lottie-player__body"></div>
</template>

<script>
import lottieWeb from "lottie-web";
import delayFunc from "@/utils/delay";
import { resolveResourceUrl } from "@/constants";

export default {
  methods: {
    async play(lottieId, options = { delay: 0, duration: 0, scale: 1 }) {
      if (this.animation) this.animation.destroy();

      const { delay, duration, scale = 1 } = options;

      this.$el.querySelectorAll(".lottie__wrapper").forEach((el) => {
        this.$el.removeChild(el);
      });

      // @duplicate
      // create child el
      const el = document.createElement("div");
      el.classList.add("lottie__wrapper");
      el.style.width = `${(100 * scale).toFixed()}%`;
      el.style.height = `${(100 * scale).toFixed()}%`;

      // Center
      el.style.position = "absolute";
      el.style.top = "50%";
      el.style.left = "50%";
      el.style.transform = "translate(-50%, -50%)";

      this.$el.appendChild(el);

      await delayFunc(delay);
      this.animation = lottieWeb.loadAnimation({
        container: el,
        renderer: "svg",
        loop: true,
        autoplay: true,
        path: resolveResourceUrl(lottieId, "lotties/background"),
      });

      try {
        // TODO: 없어도 될듯.. model 종료와 함께 정지된다
        await delayFunc(15 * 1000); // 혹시몰라서 15초로 해둔다
        if (this.animation) this.animation.destroy();
        this.$el.removeChild(el);
      } catch (error) {}
    },
    stop() {
      if (this.animation) this.animation.destroy();

      this.$el.querySelectorAll(".lottie__wrapper").forEach((el) => {
        this.$el.removeChild(el);
      });
    },
  },
  destroyed() {},
};
</script>

<style scoped>
.lottie-player__body {
  width: 100%;
  height: 100%;
}
</style>
